import { Injectable } from '@angular/core';

import { LRSMap } from 'assets/TS/LRSMap_New';
import { BehaviorSubject, Subject } from 'rxjs';
import { AttrIndexService } from './attr-index.service';
import { FishboneCode } from './fishbone.service';
import { MainDataMapLayersService } from './main-data-map-layers.service';
import { MainDataMapService } from './main-data-map.service';

import { Point, MultiPoint, LineString, MultiLineString } from 'ol/geom';
import { Fill, RegularShape, Stroke, Style, Text, Icon, Circle } from 'ol/style';
import { colors, styleAttrs } from 'assets/TS/StyleConfig';
import { Select } from 'ol/interaction';
import { GeometryType } from './common-map.service';
import { MapSharedService } from './map-shared.service';

@Injectable({
  providedIn: 'root'
})
export class InterlayerMapService {

	map: LRSMap.Map; // TODO: delete
	mapBS: BehaviorSubject<LRSMap.Map> = new BehaviorSubject(null);

	mapDrawReso = {
		fishbone: 10
	};

	mapMoveendSubject: Subject<any> = new Subject();

	qcSelectInteraction: Select;
	originalDataSelectInteraction: Select;

	readonly firstDataLayerName = 'firstDataLayer';
	readonly secondDataLayerName = 'secondDataLayer';
	readonly qcLayerName = 'qcLayer';
	readonly backgroundRefLayerName = 'backgroundRefLayer';
	readonly modifyLayerName = 'modifyLayer';
	// readonly fishboneLayerName = 'fishboneLayer';
	// readonly bgSurroundingsLayerName = 'bgSurroundingsLayer';

	initRefLayerOpacity = 0.50;

	private hitTolerance = 5;

	constructor(
		private attrIndexService: AttrIndexService,
		private mapLayerService: MainDataMapLayersService,
		private mapService: MainDataMapService,
		private mapSharedService: MapSharedService
	) { }

	addDataLayer(map: LRSMap.Map, zIndex?: number) {
		map.addLayer(this.firstDataLayerName, {
			style: (feat, reso) => {
				const geomType: GeometryType = feat.getGeometry().getType();
				switch (geomType) {
					case 'LineString':
					case 'MultiLineString':
						return this.getRefLineStyles(feat, reso);
					default:
						return this.getDefaultStyle();
				}
			},
			zIndex: zIndex++
		});
	}
	addSecondDataLayer(map: LRSMap.Map, zIndex?: number) {
		const layer = map.addLayer(this.secondDataLayerName, {
			style: (feat, reso) => {
				const geomType: GeometryType = feat.getGeometry().getType();
				switch (geomType) {
					case 'LineString':
					case 'MultiLineString':
						return this.getRefLineStyles(feat, reso);
					case 'Polygon':
					case 'MultiPolygon':
						// Check for 4-color
						return this.mapSharedService.get4ColorPolygonStyle(feat);
					default:
						return this.getDefaultStyle();
				}
			},
			zIndex: zIndex++
		});
		layer.setOpacity(this.initRefLayerOpacity);
	}
	private getDefaultStyle = () => {
		return new Style({
			image: new RegularShape({
				fill: new Fill({
					color: colors.mapFill
				}),
				points: 20,
				radius: 2,
			}),
			stroke: new Stroke({
				color: colors.mapFill,
				width: 1
			})
		});
	}
	private getRefLineStyles = (feat, reso) => {
		const geomType: GeometryType = feat.getGeometry().getType();
		const styles = [new Style({
			stroke: new Stroke({
				color: colors.mapRefLine,
				width: 2
			})
		})];
		// Arrow style
		const as = this.mapSharedService.getLineArrowStyle(feat, reso, geomType === 'MultiLineString', { color: colors.mapRefLine });
		if (as) {
			styles.push(as);
		}
		return styles;
	}
	addQcDataLayer(map: LRSMap.Map, zIndex?: number) {
		map.addLayer(this.qcLayerName, {
			style: new Style({
				image: new RegularShape({
					fill: new Fill({
						color: colors.mapError
					}),
					points: 20,
					radius: 2,
				}),
				stroke: new Stroke({
					color: colors.mapError,
					width: 3
				})
			}),
			zIndex: zIndex++
		});
	}
	addBackgroundRefLayer(map: LRSMap.Map, zIndex?: number) {
		map.addLayer(this.backgroundRefLayerName, {

			zIndex: zIndex++
		});
	}
	addDataModifyLayer(map: LRSMap.Map, zIndex?: number) {
		const layer = map.addLayer(this.modifyLayerName, {
			zIndex: zIndex
		});
		const source = layer.getSource();
		const updateFeatAttr = (feat, isOnModifyLayer: boolean) => {
			const prop = feat.getProperties();
			prop[this.attrIndexService.isFeatOnModifyLayer] = isOnModifyLayer;
			feat.setProperties(prop);
		}
		source.on('addfeature', (e) => {
			updateFeatAttr(e.feature, true);
		})
		source.on('removefeature', (e) => {
			updateFeatAttr(e.feature, false);
		});
	}

	// getFishboneStyle = (feat, reso) => {
	// 	const imgFillColor = colors.mapFill;
	// 	let strokeColor = colors.mapFill;
	// 	if (feat.getProperties()[this.attrIndexService.isLongBoneKey] || feat.getProperties()[this.attrIndexService.isCrossBoneKey]) {
	// 		strokeColor = colors.mapError;
	// 	}
	// 	//
	// 	const strokeWidth = feat.getProperties()[this.attrIndexService.isFishboneRoadKey] ? styleAttrs.fishboneRoadStrokeWidth : styleAttrs.fishboneStrikeStrokeWidth;
	// 	const baseStyle = new Style({
	// 		image: new RegularShape({
	// 			fill: new Fill({
	// 				color: colors.mapError
	// 			}),
	// 			points: 20,
	// 			radius: 2,
	// 		}),
	// 		stroke: new Stroke({
	// 			color: strokeColor,
	// 			width: strokeWidth
	// 		})
	// 	});
	// 	const styles = [baseStyle];
	// 	// Arrow style // For fishbone road only
	// 	if (feat.getProperties()[this.attrIndexService.isFishboneRoadKey]) {
	// 		const geomType = feat.getGeometry().getType();
	// 		const as = this.mapLayerService.getLineArrowStyle(reso, feat, geomType === 'MultiLineString', {
	// 			color: imgFillColor,
	// 		});
	// 		if (as) {
	// 			styles.unshift(as);
	// 		}
	// 	}
	// 	// // StartPointStyle
	// 	// const startPointStyle = this.getFishboneStartPointStyle(feat);
	// 	// if (startPointStyle) {
	// 	// 	styles.unshift(startPointStyle);
	// 	// }
	// 	return styles;
	// }
	getFishboneRoadStyle = (feat, reso) => {
		const imgFillColor = colors.mapFill;
		const styles = [];
		// Arrow style // For fishbone road only
			// if (feat.getProperties()[this.attrIndexService.isFishboneRoadKey]) {
		const geomType = feat.getGeometry().getType();
		const as = this.mapSharedService.getLineArrowStyle(feat, reso, geomType === 'MultiLineString', {
			color: imgFillColor,
		});
		if (as) {
			styles.unshift(as);
		}
			// }
	}
	getFishboneSpikeStyle = (feat) => {
		let strokeColor = colors.mapFill;
		if (feat.getProperties()[this.attrIndexService.isLongBoneKey] || feat.getProperties()[this.attrIndexService.isCrossBoneKey]) {
			strokeColor = colors.mapError;
		}
		// if (feat.getProperties()[this.attrIndexService.isLongBoneKey]) {
		// 	strokeColor = 'pink';
		// } else if (feat.getProperties()[this.attrIndexService.isCrossBoneKey]) {
		// 	strokeColor = 'green'
		// }
		//
		const strokeWidth = feat.getProperties()[this.attrIndexService.isFishboneRoadKey] ? styleAttrs.fishboneRoadStrokeWidth : styleAttrs.fishboneStrikeStrokeWidth;
		const spikeStyle = new Style({
			image: new RegularShape({
				fill: new Fill({
					color: colors.mapError
				}),
				points: 20,
				radius: 2,
			}),
			stroke: new Stroke({
				color: strokeColor,
				width: strokeWidth
			})
		});
		return [spikeStyle];
	}
	// getFishboneAddressStyle = (feat) => {
	// 	const props = feat.getProperties();
	// 	const coords = feat.getGeometry().getCoordinates();
	// 	const geomType = feat.getGeometry().getType();
	// 	let coord;
	// 	if (geomType === 'Point') {
	// 		coord = coords;
	// 	} else if (geomType === 'LineString') {
	// 		coord = coords[0];
	// 	} else if (geomType === 'MultiLineString') {
	// 		coord = coords[0][0];
	// 	}
	// 	// Mark the start point (which is the address point, not the geocode point)
	// 	if (props[this.attrIndexService.isFishboneAddrKey] && coord) {
	// 		const qaCode: FishboneCode = props[this.attrIndexService.attrKey][this.attrIndexService.qaNotesColName] ? props[this.attrIndexService.attrKey][this.attrIndexService.qaNotesColName].cd : null;
	// 		const opacity = ''; // opacity || '';
	// 		const color1 = '#FF0000' + opacity;
	// 		const color2 = '#000000' + opacity;
	// 		const rCircleLarge = 5;
	// 		const rCircleSmall = 3;
	// 		const rDiamLarge = 10;
	// 		const rDiamSmall = 5;
	// 		const rTriaLarge = 10;
	// 		let imgFillColor = 'black';
	// 		let shape: 'circle' | 'diamond' | 'triangle' | 'none' = 'circle';
	// 		let radius;
	// 		let startPointStyle;
	// 		switch (qaCode) {
	// 			case 'FS1':
	// 				imgFillColor = color2;
	// 				radius = rCircleSmall;
	// 				break;
	// 			case 'FS2':
	// 				imgFillColor = color1;
	// 				radius = rCircleSmall;
	// 				break;
	// 			case 'FS3':
	// 				imgFillColor = color2;
	// 				radius = rCircleLarge;
	// 				break;
	// 			case 'FS4':
	// 				imgFillColor = color1;
	// 				radius = rCircleLarge;
	// 				break;
	// 			case 'FS5':
	// 				imgFillColor = color1;
	// 				shape = 'diamond';
	// 				radius = rDiamLarge;
	// 				break;
	// 			case 'FS6':
	// 				imgFillColor = color1;
	// 				shape = 'diamond';
	// 				radius = rDiamLarge;
	// 				break;
	// 			case 'FS7':
	// 				imgFillColor = color1;
	// 				shape = 'diamond';
	// 				radius = rDiamSmall;
	// 				break;
	// 			case 'FS8':
	// 				imgFillColor = color1;
	// 				shape = 'diamond';
	// 				radius = rDiamSmall;
	// 				break;
	// 			case 'FS9':
	// 				imgFillColor = color1;
	// 				shape = 'triangle';
	// 				radius = rTriaLarge;
	// 				break;
	// 			case 'FSA':
	// 				imgFillColor = color2;
	// 				shape = 'none';
	// 				break;
	// 			case 'FSB':
	// 				imgFillColor = color2;
	// 				shape = 'none';
	// 				break;			
	// 		}
	// 		switch (shape) {
	// 			case 'circle':
	// 				startPointStyle = new Style({
	// 					geometry: new Point(coord),
	// 					image: new RegularShape({
	// 						fill: new Fill({
	// 							color: imgFillColor
	// 						}),
	// 						points: 20,
	// 						radius: radius,
	// 					}),
	// 					fill: new Fill({
	// 						color: imgFillColor
	// 					})
	// 				});
	// 				break;
	// 			case 'diamond':
	// 				startPointStyle = new Style({
	// 					geometry: new Point(coord),
	// 					image: new RegularShape({
	// 						fill: new Fill({
	// 							color: imgFillColor
	// 						}),
	// 						points: 4,
	// 						radius: radius,
	// 						angle: Math.PI / 4,
	// 						rotation: Math.PI / 4
	// 					}),
	// 					fill: new Fill({
	// 						color: imgFillColor
	// 					})
	// 				});
	// 				break;
	// 			case 'triangle':
	// 				startPointStyle = new Style({
	// 					geometry: new Point(coord),
	// 					image: new RegularShape({
	// 						angle: 0,
	// 						fill: new Fill({
	// 							color: imgFillColor
	// 						}),
	// 						points: 3,
	// 						radius: radius,
	// 					}),
	// 					fill: new Fill({
	// 						color: imgFillColor
	// 					})
	// 				});
	// 				break;
	// 		}
	// 		return startPointStyle;
	// 	}
	// }

	addSelectInteraction(qcCallback?, originCallBack?, qcCondition?, originCondition?) {
		const qcLayer = this.map.addedLayers[this.qcLayerName];
		const modifyLayer = this.map.addedLayers[this.modifyLayerName];
		const selectSingleClick = new Select({
			style: this.mapLayerService.getBasicHighlightStyle,
			layers: [qcLayer, modifyLayer],
			hitTolerance: this.hitTolerance,
			condition: qcCondition,
			toggleCondition: () => false
		});
		if (qcCallback) {
			selectSingleClick.on('select', (e) => {
				qcCallback(e, selectSingleClick);
			});
		}
		this.map.olMap.addInteraction(selectSingleClick);
		this.qcSelectInteraction = selectSingleClick;

		const firstLayer = this.map.addedLayers[this.firstDataLayerName];
		const secondLayer = this.map.addedLayers[this.secondDataLayerName];
		const originalDataSelectSingleClick = new Select({
			style: this.mapLayerService.getBasicHighlightStyle, // this.mapLayerService.getDataSelectionStyle,
			layers: [firstLayer, secondLayer],
			hitTolerance: this.hitTolerance,
			condition: originCondition,
			toggleCondition: () => false
		});
		if (originCallBack) {
			originalDataSelectSingleClick.on('select', (e) => {
				originCallBack(e, originalDataSelectSingleClick);
			});
		}
		this.map.olMap.addInteraction(originalDataSelectSingleClick);

		// TODO
		// this.originalDataSelectInteraction = originalDataSelectSingleClick
	}

}
